import React, { useState, useRef, useEffect } from 'react';
import styles from './dropdown-category.module.scss';
import Rectangle from '../../../../assets/img/Rectangle.svg';

const DropdownCategory = ({ selected, setSelected, options, placeholder }) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isActive && ref.current && !ref.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isActive]);

  return (
    <div className={styles.dropdown} ref={ref}>
      <div
        className={styles.dropdownBtn}
        onKeyDown={() => {}}
        onClick={() => setIsActive(!isActive)}
      >
        <p className={styles.dropdownSelect__label}>
          {selected || <span style={{ color: '#8D8D8D', fontSize: '14px' }}>{placeholder}</span>}
        </p>
        <img src={Rectangle} alt="" width="10" height="10" />
      </div>

      <div
        className={styles.dropdownContent}
        style={{ maxHeight: isActive && '260px', overflowY: isActive && 'auto' }}
      >
        {isActive &&
          options &&
          options?.map((option) => {
            return (
              <div
                key={option?.id}
                onKeyDown={() => {}}
                onClick={() => {
                  setSelected(option);
                  setIsActive(false);
                }}
                className={styles.dropdownItem}
              >
                {option?.name}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default DropdownCategory;
